import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// material-ui
import { Box, Button, Card, Divider, Fab, Grid, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// project imports
import { BASE_PATH } from "config";
import { gridSpacing } from "store/constant";

// assets
import AccountTreeTwoToneIcon from "@mui/icons-material/AccountTreeTwoTone";
import AddIcon from "@mui/icons-material/AddTwoTone";
import { IconTallymark1 } from "@tabler/icons";
import ImportModal from "./ImportModal";

const linkSX = {
  display: "flex",
  color: "grey.900",
  textDecoration: "none",
  alignContent: "center",
  alignItems: "center",
};

// ==============================|| BREADCRUMBS ||============================== //

const Breadcrumbs = ({ card, divider, icon, icons, maxItems, navigation, rightAlign, separator, title, titleBottom, ...others }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  // show a right sidebar when clicked on new product
  const [open, setOpen] = React.useState(false);
  const handleClickOpenDialog = (url) => {
    // redirigir ruta a la pantalla de nueva categoria
    // // console.log(texto);
    navigate(url);
  };
  const handleClickOpenImport = () => {
    // abrir modal de importar productos
    setOpen(true);
  };
  const handleCloseDialog = () => {
    setOpen(false);
  };
  const iconStyle = {
    marginRight: theme.spacing(0.75),
    marginTop: `-${theme.spacing(0.25)}`,
    width: "1rem",
    height: "1rem",
    color: theme.palette.secondary.main,
  };

  const [main, setMain] = useState();
  const [item, setItem] = useState();

  // set active item state
  const getCollapse = (menu) => {
    if (menu.children) {
      menu.children.filter((collapse) => {
        if (collapse.type && collapse.type === "collapse") {
          getCollapse(collapse);
        } else if (collapse.type && collapse.type === "item") {
          if (document.location.pathname === BASE_PATH + collapse.url) {
            setMain(menu);
            setItem(collapse);
          }
        }
        return false;
      });
    }
  };

  useEffect(() => {
    navigation?.items?.map((menu) => {
      if (menu.type && menu.type === "group") {
        getCollapse(menu);
      }
      return false;
    });
  });

  // item separator
  const SeparatorIcon = separator;
  const separatorIcon = separator ? <SeparatorIcon stroke={1.5} size="1rem" /> : <IconTallymark1 stroke={1.5} size="1rem" />;

  let mainContent;
  let itemContent;
  let breadcrumbContent = <Typography />;
  let itemTitle = "";
  let CollapseIcon;
  let ItemIcon;

  // collapse item
  if (main && main.type === "collapse") {
    CollapseIcon = main.icon ? main.icon : AccountTreeTwoToneIcon;
    mainContent = (
      <Typography component={Link} to="#" variant="subtitle1" sx={linkSX}>
        {icons && <CollapseIcon style={iconStyle} />}
        {main.title}
      </Typography>
    );
  }

  // items
  if (item && item.type === "item") {
    itemTitle = item.title;

    ItemIcon = item.icon ? item.icon : AccountTreeTwoToneIcon;
    itemContent = (
      <Typography
        variant="subtitle1"
        sx={{
          display: "flex",
          textDecoration: "none",
          alignContent: "center",
          alignItems: "center",
          color: "grey.500",
        }}>
        {icons && <ItemIcon style={iconStyle} />}
        {itemTitle}
      </Typography>
    );

    // main
    if (item.breadcrumbs !== false) {
      // console.log(item);
      breadcrumbContent = (
        <Card
          sx={{
            marginBottom: card === false ? 0 : theme.spacing(gridSpacing),
            border: card === false ? "none" : "1px solid",
            borderColor: theme.palette.mode === "dark" ? theme.palette.background.default : theme.palette.primary[200] + 75,
            background: card === false ? "transparent" : theme.palette.background.default,
          }}
          {...others}>
          <Box sx={{ p: 2, pl: card === false ? 0 : 2 }}>
            <Grid container direction={rightAlign ? "row" : "column"} justifyContent={rightAlign ? "space-between" : "flex-start"} alignItems={rightAlign ? "center" : "flex-start"} spacing={1}>
              {title && !titleBottom && (
                <Grid item>
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    {item.title}
                  </Typography>
                </Grid>
              )}
              <Grid item>
                {item.btn_1 && (
                  <Button variant="text" onClick={() => handleClickOpenImport()}>
                    {item.btn_1.title}
                  </Button>
                )}
                {item.btn_2 && (
                  <Tooltip title="Agregar Producto">
                    <Fab variant="extended" color="primary" onClick={() => handleClickOpenDialog(item.url_create)} sx={{ boxShadow: "none", ml: 1, minHeight: 32 }}>
                      <AddIcon fontSize="small" />
                      {item.btn_2.title}
                    </Fab>
                  </Tooltip>
                )}
              </Grid>
              {title && titleBottom && (
                <Grid item>
                  <Typography variant="h3" sx={{ fontWeight: 500 }}>
                    {item.title}
                  </Typography>
                </Grid>
              )}
            </Grid>
            <ImportModal open={open} handleCloseDialog={handleCloseDialog} />
          </Box>
          {card === false && divider !== false && <Divider sx={{ borderColor: theme.palette.primary.main, mb: gridSpacing }} />}
        </Card>
      );
    }
  }

  return breadcrumbContent;
};

Breadcrumbs.propTypes = {
  card: PropTypes.bool,
  divider: PropTypes.bool,
  icon: PropTypes.bool,
  icons: PropTypes.bool,
  maxItems: PropTypes.number,
  navigation: PropTypes.object,
  rightAlign: PropTypes.bool,
  separator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  title: PropTypes.bool,
  url_create: PropTypes.string,
  titleBottom: PropTypes.bool,
  btn_1: PropTypes.bool,
  btn_2: PropTypes.bool,
  hidden: PropTypes.bool,
};

export default Breadcrumbs;
